module.exports = __webpack_public_path__ + "img/service-03.d4987289.svg";